<script setup lang="ts">
import { PublicSellerShopsQuery } from '@gql/PublicSellerShopsQuery'

const t2 = useT2({
  Shops: 'Parduotuvės',
  Address: 'Adresas',
  City: 'Miestas',
})

const { handle } = useSeller('server')
const sellerId = useSellerId('retail')
const slugV = useParams((i) => helpers.unArray(i.slug))
const { myLink } = useLinks()

const { ui: items } = useApolloWrap2<gen.PublicSellerShopsQuery, gen.PublicSellerShopsQueryVariables>(PublicSellerShopsQuery)({
  vars() {
    const _id = sellerId.value
    if (!_id) return
    return { input: { seller: { _id }, findOne: undefined } }
  },
  ui: (i) => helpers.arr(i?.publicSellerShops?.items),
})

const selectedDoc = computed(() => helpers.arrFindId(items.value, slugV.value, (i) => i.id))

const { ui: full } = useApolloWrap2<gen.PublicSellerShopsQuery, gen.PublicSellerShopsQueryVariables>(PublicSellerShopsQuery)({
  vars() {
    const slug = slugV.value
    const _id = sellerId.value
    if (!_id || !slug || selectedDoc.value) return
    return { input: { seller: { _id }, findOne: { slug } } }
  },
  ui: (i) => helpers.arr(i?.publicSellerShops?.items).at(0),
})

useHead({
  title: t2('Shops'),
})
// useServerHead({
//   script: [
//     seoSchema({
//       '@type': 'ItemList',
//       name: 'Our Store Locations',
//       itemListElement: [
//         {
//           '@type': 'ListItem',
//           position: 1,
//           item: {
//             '@type': 'LocalBusiness',
//             name: 'Shop 1',
//             image: 'https://example.com/images/shop1.jpg',
//             address: {
//               '@type': 'PostalAddress',
//               streetAddress: '123 Main Street',
//               addressLocality: 'Anytown',
//               addressRegion: 'CA',
//               postalCode: '12345',
//               addressCountry: 'US',
//             },
//             telephone: '+1-555-555-1234',
//             openingHours: 'Mo-Fr 09:00-18:00',
//             url: 'https://example.com/shop1',
//             geo: {
//               '@type': 'GeoCoordinates',
//               latitude: '37.7749',
//               longitude: '-122.4194',
//             },
//             sameAs: 'https://www.facebook.com/shop1',
//           },
//         },
//         {
//           '@type': 'ListItem',
//           position: 2,
//           item: {
//             '@type': 'LocalBusiness',
//             name: 'Shop 2',
//             image: 'https://example.com/images/shop2.jpg',
//             address: {
//               '@type': 'PostalAddress',
//               streetAddress: '456 Elm Street',
//               addressLocality: 'Othertown',
//               addressRegion: 'NY',
//               postalCode: '67890',
//               addressCountry: 'US',
//             },
//             telephone: '+1-555-555-5678',
//             openingHours: 'Mo-Sa 10:00-20:00',
//             url: 'https://example.com/shop2',
//             geo: {
//               '@type': 'GeoCoordinates',
//               latitude: '40.7128',
//               longitude: '-74.0060',
//             },
//             sameAs: 'https://www.instagram.com/shop2',
//           },
//         },
//       ],
//     }),
//   ],
// })

// {
//   '@type': 'LocalBusiness',
//   name: 'Example Cafe',
//   url: 'https://www.examplecafe.com',
//   image: 'https://www.examplecafe.com/images/logo.png',
//   logo: 'https://www.examplecafe.com/images/logo.png',
//   description: 'Example Cafe serves the best coffee and pastries in the city.',
//   address: {
//     '@type': 'PostalAddress',
//     streetAddress: '123 Main St',
//     addressLocality: 'Example City',
//     addressRegion: 'CA',
//     postalCode: '90210',
//     addressCountry: 'US',
//   },
//   telephone: '+1-800-555-5555',
//   openingHours: 'Mo-Fr 08:00-18:00',
//   geo: {
//     '@type': 'GeoCoordinates',
//     latitude: '37.7749',
//     longitude: '-122.4194',
//   },
// sameAs: sameAs(),
// },
</script>

<template>
  <InfoPage
    :title="t2('Shops')"
    :full="selectedDoc || full"
    :items="items"
    :slug="slugV"
    :back="handle ? myLink('info-shops', {}) : undefined"
    :fullui="(i) => ({ documentId: i.document?._id, image: i.image, title: i.title.value, slugMath: i.id })"
    :ui="
      (i) => ({
        id: i.id,
        image: i.image,
        title: i.title.value,
        to: handle ? myLink('info-shops-slug', { slug: i.id }) : undefined,
      })
    "
  >
    <!-- :back="handle ? myLink('@seller-info-shops', { seller: handle }) : undefined" -->
    <!-- to: handle ? myLink('@seller-info-shops-slug', { slug: i.id, seller: handle }) : undefined, -->

    <template #full="{ item }">
      <UiLine :label="t2('City')" :value="item?.city?.value" />
      <UiLine :label="t2('Address')" :value="item?.address?.value" />
      <SellerSocial :contacts="item?.contacts" :seller-id="sellerId" />
    </template>

    <template #default="{ item }">
      <UiLine :label="t2('City')" :value="item?.city?.value" />
      <UiLine :label="t2('Address')" :value="item?.address?.value" />
      <SellerSocial :contacts="item.contacts" :seller-id="sellerId" />
    </template>
  </InfoPage>
</template>
